import { useState, useEffect } from "react";
import RightSideDetails from "../global/rightSideDetails";
import swal from 'sweetalert2';
import { getVendorMasterAll } from "../api/vendorAPI";
import VendorFeeCalendarTab from "./VendorFeeCalendarTab";
import AddFeeCalendarModal from "./AddFeeCalendarModal";

const VendorFeeCalendar = (props) => {

    const [vendorList,       setVendorList]       = useState([]);
    const [vendorDetails,    setVendorDetails]    = useState(null);
    const [isInit,           setIsInit]           = useState(true);
    const [rightSideDetails, setRightSideDetails] = useState(false);

    // Add/Edit Fee Calendar modal — owned here in the master file
    const [showModal,        setShowModal]        = useState(false);
    const [editCalendar,     setEditCalendar]     = useState(null);
    const [refreshToken,     setRefreshToken]     = useState(0);

    useEffect(() => {
        props.title("Partner Fee Calendar", "vendor-fee-calendar");
        fetchVendorMaster();
    }, []);

    useEffect(() => {
        if (!isInit) fillDataTable();
    }, [vendorList]);

    useEffect(() => {
        if (rightSideDetails) {
            Config.Core.OpenDrawer();
        } else {
            setVendorDetails(null);
        }
    }, [rightSideDetails]);

    const fetchVendorMaster = async () => {
        try {
            const vendors = await getVendorMasterAll();
            isInit ? setIsInit(false) : $('#tblFeeVendor').KTDatatable().destroy();
            setVendorList(vendors);
        } catch (err) {
            swal.fire({ icon: 'error', titleText: err.message });
        }
    };

    function fillDataTable() {
        const dataTable = $('#tblFeeVendor').KTDatatable({
            data: {
                saveState : false,
                source    : vendorList,
                pageSize  : 20,
            },
            layout: {
                scroll : true,
                height : $(window).height() - 250,
                footer : false,
            },
            sortable   : true,
            pagination : true,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field : 'VendorName',
                    title : 'Partner',
                    template: function (row) {
                        return `<div class="kt-user-card-v2">
                                    <div class="kt-user-card-v2__pic">
                                        <div class="kt-badge kt-badge--xl kt-badge--info">${row.VendorName.substring(0, 1)}</div>
                                    </div>
                                    <div class="kt-user-card-v2__details text-clip">
                                        <span class="kt-user-card-v2__name text-clip">${row.VendorName}</span>
                                        <span class="kt-user-card-v2__desc text-clip">${row.ContactPerson || ''}</span>
                                    </div>
                                </div>`;
                    },
                },
                {
                    field : 'Email',
                    title : 'Email',
                    template: function (row) {
                        return `<span>${row.Email || '-'}</span>`;
                    },
                },
                {
                    field : 'Phone',
                    title : 'Phone',
                    template: function (row) {
                        return `<span>${row.Phone || '-'}</span>`;
                    },
                    width: 130,
                },
                {
                    field : 'Status',
                    title : 'Status',
                    template: function (row) {
                        return row.Status
                            ? '<span class="kt-badge kt-badge--success kt-badge--pill padding-lr30 padding-tb10">Active</span>'
                            : '<span class="kt-badge kt-badge--grey kt-badge--pill padding-lr30 padding-tb10">Inactive</span>';
                    },
                    width: 100,
                },
            ],
        });

        $('#root .kt-grid--hor').addClass('max-width100');
        $('#tblFeeVendor .kt-datatable__table').addClass('overflow-x-auto');

        dataTable.on('click', 'tr', function () {
            const index = ($("tr").index(this) - 1);
            if (dataTable.dataSet[index]) {
                setVendorDetails(dataTable.dataSet[index]);
                setRightSideDetails(true);
            }
        });
    }

    const closeDrawer = () => {
        Config.Core.CloseDrawer();
        setTimeout(() => setRightSideDetails(false), 200);
    };

    const openAddCalendar = () => {
        setEditCalendar(null);
        setShowModal(true);
    };

    const openEditCalendar = (calendar) => {
        setEditCalendar(calendar);
        setShowModal(true);
    };

    // Bump the token so the tab refetches after a successful save
    const handleCalendarSaved = () => {
        setRefreshToken((t) => t + 1);
    };

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content">
                <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__head kt-portlet__head--lg padding-l0">
                            <div className="kt-portlet__head-label">
                                <div className="row align-items-center margin-l10">
                                    <div className="col-md-12 kt-margin-b-20-tablet-and-mobile margin-b0">
                                        <div className="kt-input-icon kt-input-icon--left">
                                            <input
                                                type="text"
                                                className="form-control clientSearch"
                                                placeholder="Search Partner..."
                                                id="generalSearch"
                                            />
                                            <span className="kt-input-icon__icon kt-input-icon__icon--left">
                                                <span><i className="la la-search"></i></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            <div id="tblFeeVendor" className="kt-datatable table-striped clickable"></div>

                            {/* Fee Calendar Sidebar */}
                            {rightSideDetails && vendorDetails && (
                                <RightSideDetails title="Vendor Fee Calendar" onCloseDrawer={closeDrawer}>
                                    <div className="kt-portlet">
                                        <div className="kt-portlet__body">
                                            <div className="kt-widget kt-widget--user-profile-3">
                                                <div className="kt-widget__top">
                                                    <div className="kt-widget__pic kt-widget__pic--brand kt-font-brand kt-font-boldest">
                                                        {vendorDetails.VendorName.substring(0, 1)}
                                                    </div>
                                                    <div className="kt-widget__content">
                                                        <div className="kt-widget__head">
                                                            <span className="kt-widget__username">
                                                                {vendorDetails.VendorName}{' '}
                                                                <span className={`kt-badge kt-badge--${vendorDetails.Status ? 'success' : 'grey'} kt-badge--inline kt-badge--pill padding-lr10`}>
                                                                    {vendorDetails.Status ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </span>
                                                        </div>
                                                        <div className="kt-widget__subhead padding-t0">
                                                            {vendorDetails.ContactPerson && (
                                                                <span className="padding-r10">
                                                                    <i className="flaticon2-user"></i>
                                                                    {vendorDetails.ContactPerson}
                                                                </span>
                                                            )}
                                                            {vendorDetails.Email && (
                                                                <span className="padding-r10">
                                                                    <i className="flaticon2-new-email"></i>
                                                                    {vendorDetails.Email}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="kt-portlet kt-portlet--mobile">
                                        <div className="kt-portlet__body padding-t0">
                                            <VendorFeeCalendarTab
                                                vendorID={vendorDetails.ID}
                                                onAdd={openAddCalendar}
                                                onEdit={openEditCalendar}
                                                refreshToken={refreshToken}
                                            />
                                        </div>
                                    </div>
                                </RightSideDetails>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Fee Calendar modal — mounted at master level, driven by the tab */}
            {vendorDetails && (
                <AddFeeCalendarModal
                    show={showModal}
                    onDismissModal={() => setShowModal(false)}
                    vendorID={vendorDetails.ID}
                    feeCalendar={editCalendar}
                    onSave={handleCalendarSaved}
                />
            )}
        </>
    );
};

export default VendorFeeCalendar;
